import React from "react";
import "../../css/designSystem/TestimonialCard.css";
import { ReactComponent as QuoteIcon } from "../../assets/icons/QuotationMark.svg";

const Card = ({ title, content, author }) => {
  return (
    <div className="testimonial-card card">
      <h3 className="burgandy align-center">{title}</h3>
      <div className="content grey align-center">{content}</div>
      {/* <div className="content-semibold  burgandy align-left">{author}</div> */}
    </div>
  );
};

export default Card;
